import { BaseModel } from '../base/base-model'

/**
 * @memberOf loavies.models.user
 * @constructor
 */
export class UserModel extends BaseModel {
  /**
   * @param {string} id
   * @param {string} [email]
   * @param {string} [firstName]
   * @param {string} [lastName]
   * @param {null|string} displayName
   * @param {string} abbreviatedName
   * @param {string} [bio]
   * @param {loavies.models.image.ImageModel} [image]
   * @param {Date} createdAt
   * @param {boolean} banned
   * @param {boolean} deleted
   * @param {loavies.models.user.UserPublicDataModel} [publicData]
   * @param {loavies.models.user.UserPrivateDataModel} [privateData]
   * @param {loavies.models.user.UserMetaDataModel} [metaData]
   */
  constructor({
    id,
    email,
    firstName,
    lastName,
    displayName,
    abbreviatedName,
    bio,
    image,
    createdAt,
    banned,
    deleted,
    publicData,
    privateData,
    metaData,
  }) {
    super()

    /** @type {string} */
    this.id = id

    /** @type {null|string} */
    this.email = email ?? null

    /** @type {null|string} */
    this.firstName = firstName ?? null

    /** @type {null|string} */
    this.lastName = lastName ?? null

    /** @type {null|string} */
    this.displayName = displayName

    /** @type {string} */
    this.abbreviatedName = abbreviatedName

    /** @type {null|string} */
    this.bio = bio ?? null

    /** @type {null|loavies.models.image.ImageModel} */
    this.image = image ?? null

    /** @type {Date} */
    this.createdAt = createdAt

    /** @type {boolean} */
    this.banned = banned

    /** @type {boolean} */
    this.deleted = deleted

    /** @type {null|loavies.models.user.UserPublicDataModel} */
    this.publicData = publicData ?? null

    /** @type {null|loavies.models.user.UserPrivateDataModel} */
    this.privateData = privateData ?? null

    /** @type {null|loavies.models.user.UserMetaDataModel} */
    this.metaData = metaData ?? null
  }
}

export const STORE_GRID_TYPES = {
  DEFAULT: 'default',
  ROWS: 'rows',
  PLAYFUL: 'playful',
}

export const USER_LABELS = {
  TRUSTED_SELLER: 'trusted_seller',
  QUICK_RESPONDER: 'quick_responder',
  SUPER_SELLER: 'super_seller',
  SPEEDY_SHIPPER: 'speedy_shipper',
}
